cv.getRGBComponents = function(color) {
  rgb = color.replace(/[^\d,]/g, '').split(',');
    return {
       R: parseInt(rgb[0]),
       G: parseInt(rgb[1]),
       B: parseInt(rgb[2])
    };
};